module.exports = __webpack_public_path__ + "img/Haufe.3756e5be.jpg";